module.exports = __webpack_public_path__ + "static/img/mobile_client.fc2b154.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile_client.png
// module id = zm99
// module chunks = 0